import type { NskResponse } from '~/models/Api';
import { postRequest, putRequest } from '~/utils/api/api_handler';
import type { DealEstimationEdit } from '~/models/DealEstimate';
import type { DealConstruction } from '~/models/DealConstruction';

const paths = {
  update: '/deals/:deal_id/deal_estimations/:id',
  updateSeq: '/deals/:deal_id/deal_estimations/update_seq'
};

export const update = async (
  dealEstimation: DealEstimationEdit,
  dealEstimationId: number,
  dealId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update
      .replace(':id', String(dealEstimationId))
      .replace(':deal_id', String(dealId)),
    { dealEstimation }
  );

export const updateSeq = async (
  dealEstimations: DealConstruction[],
  dealId: number
): Promise<NskResponse<void>> =>
  postRequest(paths.updateSeq.replace(':deal_id', String(dealId)), {
    dealEstimations
  });
